import React from 'react';
import OnContent from './OnContent';
import OffContent from './OffContent';
import ToggleButton from './ToggleButton';
export default class Toggle extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            isOn: this.props.value,
        };
        this.handleToggle = event => {
            const { onChange } = this.props;
            event && event.preventDefault();
            this.setState(state => ({ isOn: !state.isOn }));
            onChange && onChange(!this.state.isOn);
        };
    }
    render() {
        const { children, onTitle, offTitle, isFilterBar } = this.props;
        const { isOn } = this.state;
        const title = isOn ? onTitle : offTitle;
        return (<>
        {React.Children.map(children, child => React.cloneElement(child, {
            isOn,
            title,
            onToggle: this.handleToggle,
            isFilterBar,
        }))}
      </>);
    }
}
Toggle.defaultProps = {
    onTitle: 'Show',
    offTitle: 'Hide',
    isFilterBar: false,
    value: false,
};
Toggle.ToggleButton = ToggleButton;
Toggle.OffContent = OffContent;
Toggle.OnContent = OnContent;
